import {useMemo} from 'react';
import {useJsonFetch} from '@sail/data';
import {AnyNotification} from 'mkt-ssr/lib/notifications/types';
import {DEFAULT_PREFIX, usePrefix} from 'mkt-ssr/lib/globalization';

export type NotificationsAPIResponse = Array<AnyNotification>;

const NOTIFICATIONS_ENDPOINT_BASE = '/notifications?as=json';

function getNotificationsUrl(prefix: string): string {
  const baseUrl =
    prefix === DEFAULT_PREFIX.prefix
      ? NOTIFICATIONS_ENDPOINT_BASE
      : `/${prefix}${NOTIFICATIONS_ENDPOINT_BASE}`;

  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const showCookieBanner = urlParams.get('__showCookieBanner');
    if (showCookieBanner === 'true') {
      return `${baseUrl}&__showCookieBanner=true`;
    }
  }

  return baseUrl;
}

export function useRealNotifications(): Array<AnyNotification> {
  const prefix = usePrefix();

  const {data} = useJsonFetch<NotificationsAPIResponse>(
    // NB: This is not a pattern we want to replicate, but
    // we cannot pipe this through `createRoute()` because that
    // generates an object, which this method cannot handle, so
    // we manually construct it here. Realistically we should make
    // this endpoint take this as an argument/param, not based on
    // the localization segment, but it's pretty entrenched
    // there at this point.
    getNotificationsUrl(prefix),
  );

  return useMemo(() => data || [], [data]);
}

export function useNotifications(): Array<AnyNotification> {
  return useRealNotifications();
}
